import React from "react";
import { Table } from "reactstrap";
import { Link } from "react-router-dom";
import {
  fmtHoverDateTime,
  fmtOrderRupee,
} from "../../pages/storeSalesDashboardHelpers";

export default function CreditAdjustmentHistory({ adjustments, creditNoteValue }) {
  const rows = Array.isArray(adjustments) ? adjustments : [];
  const cnValue =
    creditNoteValue != null && Number.isFinite(Number(creditNoteValue))
      ? Number(creditNoteValue)
      : null;

  return (
    <Table bordered size="sm" className="mb-0">
      <thead>
        <tr>
          <th>Order</th>
          <th className="text-end">Order value</th>
          <th className="text-end">Credit used on project</th>
          <th>Adjusted at</th>
        </tr>
      </thead>
      <tbody>
        {rows.length === 0 ? (
          <tr>
            <td colSpan={4} className="text-muted text-center py-3">
              No adjustments yet.
              {cnValue != null ? (
                <span className="d-block mt-1 small">
                  Credit value: {fmtOrderRupee(cnValue)}
                </span>
              ) : null}
            </td>
          </tr>
        ) : (
          rows.map((row) => (
            <tr key={row.id ?? `${row.project_id}-${row.adjusted_at}`}>
              <td>
                {row.project_id ? (
                  <Link
                    to={`/projects/${row.project_id}`}
                    className="text-decoration-none fw-semibold"
                  >
                    {row.project_name || `Order #${row.project_id}`}
                  </Link>
                ) : (
                  row.project_name || "—"
                )}
              </td>
              <td className="text-end">
                {row.project_value != null
                  ? fmtOrderRupee(row.project_value)
                  : "—"}
              </td>
              <td className="text-end">
                {row.project_credit_total != null
                  ? fmtOrderRupee(row.project_credit_total)
                  : "—"}
              </td>
              <td className="small">
                {row.adjusted_at ? fmtHoverDateTime(row.adjusted_at) : "—"}
              </td>
            </tr>
          ))
        )}
      </tbody>
    </Table>
  );
}
